<template>
    <div v-click-outside="hide">
        <div v-if="condition.isShow" style="position: relative">
            <div class="info-block">
                <div class="option">Ім'я</div>
                <div class="info">
                    {{ client.fullName }}
                </div>
                <div class="option">Телефон</div>
                <div class="info">
                    {{ client.phone }}
                </div>
                <div class="option">Пошта</div>
                <div class="info" style="margin-bottom: 16px">
                    {{ client.email }}
                </div>
            </div>
        </div>
        <div class="icon-block" >
            <svg style="margin-bottom: 4px; margin-left: 10px;" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M2.4 1C1.76348 1 1.15303 1.27656 0.702944 1.76884C0.252856 2.26113 0 2.92881 0 3.625V12.375C0 13.0712 0.252856 13.7389 0.702944 14.2312C1.15303 14.7234 1.76348 15 2.4 15H13.6C14.2365 15 14.847 14.7234 15.2971 14.2312C15.7471 13.7389 16 13.0712 16 12.375V3.625C16 2.92881 15.7471 2.26113 15.2971 1.76884C14.847 1.27656 14.2365 1 13.6 1H2.4ZM1.6 3.625C1.6 3.39294 1.68429 3.17038 1.83431 3.00628C1.98434 2.84219 2.18783 2.75 2.4 2.75H13.6C13.8122 2.75 14.0157 2.84219 14.1657 3.00628C14.3157 3.17038 14.4 3.39294 14.4 3.625V12.375C14.4 12.6071 14.3157 12.8296 14.1657 12.9937C14.0157 13.1578 13.8122 13.25 13.6 13.25H2.4C2.18783 13.25 1.98434 13.1578 1.83431 12.9937C1.68429 12.8296 1.6 12.6071 1.6 12.375V3.625ZM4.8 7.125C4.8 6.89294 4.88429 6.67038 5.03431 6.50628C5.18434 6.34219 5.38783 6.25 5.6 6.25C5.81217 6.25 6.01566 6.34219 6.16569 6.50628C6.31571 6.67038 6.4 6.89294 6.4 7.125C6.4 7.35706 6.31571 7.57962 6.16569 7.74372C6.01566 7.90781 5.81217 8 5.6 8C5.38783 8 5.18434 7.90781 5.03431 7.74372C4.88429 7.57962 4.8 7.35706 4.8 7.125ZM8 7.125C8 7.70425 7.828 8.24063 7.5376 8.67375C8.0336 9.08063 8.396 9.62575 8.6928 10.1875C8.74616 10.287 8.78099 10.3972 8.79528 10.5115C8.80957 10.6258 8.80305 10.7421 8.77608 10.8537C8.74911 10.9652 8.70224 11.0699 8.63815 11.1615C8.57406 11.2532 8.49403 11.3301 8.40266 11.3878C8.31129 11.4455 8.21039 11.4829 8.10577 11.4977C8.00114 11.5126 7.89486 11.5047 7.79305 11.4745C7.69123 11.4442 7.59588 11.3923 7.5125 11.3216C7.42912 11.2509 7.35935 11.1628 7.3072 11.0625C7.0568 10.5891 6.8192 10.268 6.5632 10.0632C6.3272 9.87337 6.032 9.75 5.6 9.75C5.168 9.75 4.8736 9.8725 4.636 10.0632C4.38 10.268 4.1432 10.5883 3.892 11.0634C3.78262 11.2573 3.60839 11.3969 3.40637 11.4525C3.20435 11.5081 2.99047 11.4753 2.8102 11.3611C2.62993 11.2469 2.4975 11.0603 2.44107 10.841C2.38464 10.6216 2.40865 10.3869 2.508 10.1866C2.804 9.62575 3.1672 9.08062 3.6624 8.67462C3.43875 8.33995 3.29074 7.9521 3.23051 7.54283C3.17027 7.13355 3.19951 6.71449 3.31584 6.31996C3.43216 5.92542 3.63227 5.56663 3.89976 5.27295C4.16726 4.97928 4.49455 4.75907 4.85483 4.63036C5.21511 4.50165 5.59813 4.46809 5.97255 4.53244C6.34697 4.59679 6.70213 4.75721 7.00895 5.00058C7.31577 5.24394 7.56554 5.56332 7.7378 5.93258C7.91006 6.30183 7.99991 6.71046 8 7.125ZM10.4 4.5C10.1878 4.5 9.98434 4.59219 9.83432 4.75628C9.68429 4.92038 9.6 5.14294 9.6 5.375C9.6 5.60706 9.68429 5.82962 9.83432 5.99372C9.98434 6.15781 10.1878 6.25 10.4 6.25H12.8C13.0122 6.25 13.2157 6.15781 13.3657 5.99372C13.5157 5.82962 13.6 5.60706 13.6 5.375C13.6 5.14294 13.5157 4.92038 13.3657 4.75628C13.2157 4.59219 13.0122 4.5 12.8 4.5H10.4ZM10.4 7.125C10.1878 7.125 9.98434 7.21719 9.83432 7.38128C9.68429 7.54538 9.6 7.76794 9.6 8C9.6 8.23206 9.68429 8.45462 9.83432 8.61872C9.98434 8.78281 10.1878 8.875 10.4 8.875H12.8C13.0122 8.875 13.2157 8.78281 13.3657 8.61872C13.5157 8.45462 13.6 8.23206 13.6 8C13.6 7.76794 13.5157 7.54538 13.3657 7.38128C13.2157 7.21719 13.0122 7.125 12.8 7.125H10.4ZM10.4 9.75C10.1878 9.75 9.98434 9.84219 9.83432 10.0063C9.68429 10.1704 9.6 10.3929 9.6 10.625C9.6 10.8571 9.68429 11.0796 9.83432 11.2437C9.98434 11.4078 10.1878 11.5 10.4 11.5H11.2C11.4122 11.5 11.6157 11.4078 11.7657 11.2437C11.9157 11.0796 12 10.8571 12 10.625C12 10.3929 11.9157 10.1704 11.7657 10.0063C11.6157 9.84219 11.4122 9.75 11.2 9.75H10.4Z" fill="#999DA6"/>
            </svg>

            <a style="margin-left: 3px;" @click="handle()" href="javascript:void(0);">
                <span class="option">Контакти</span>
            </a>
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'

    export default {
        name: 'ClientInfo',
        directives: { ClickOutside },
        props: {
            client: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        data: function () {
            return {
                condition: {
                    isShow: false,
                },
            }
        },
        methods: {
            hide: function () {
                return this.condition.isShow = false;
            },
            handle: function () {
                return this.condition.isShow = ! this.condition.isShow
            }
        }
    }
</script>

<style lang="scss" scoped>
    .info-block {
        padding-left: 30px;
        z-index: 2;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
        border-radius: 5px;
        width: 320px;
        position: absolute;
        background: #FFFFFF;
        top: 30px;
        left: -158px;

        .option {
            margin-top: 16px;
            font-family: Circe,serif;
            font-style: normal;
            font-weight: normal;
            font-size: 15px;
            line-height: 22px;
            color: #999DA6;
        }
        .info {
            font-family: Circe, serif;
            font-style: normal;
            font-weight: bold;
            font-size: 20px;
            line-height: 29px;

            color: #24282C;
        }
    }

</style>
